import {
  CubeIcon,
  FileSlidersIcon,
  FileKeyIcon,
  FolderLibraryIcon,
  Globe02Icon,
  ComputerIcon,
  ServerStack01Icon,
  UserIcon,
  UserMultipleIcon,
  type TerraIcon,
} from '@terra/ui-icons';
import { token } from '@terra/ui-styled-system';
import type { InternalNetworkAdEntityKindSchema } from '@terra/shared-schemas-orchestrator';
import type { z } from 'zod';

export type InternalNetworkAdEntityKind = z.infer<
  typeof InternalNetworkAdEntityKindSchema
>;
export const ENTITY_KIND_COLOR_MAP: Record<
  InternalNetworkAdEntityKind,
  string
> = {
  USER: 'blue',
  GROUP: 'purple',
  COMPUTER: 'gray',
  OU: 'orange',
  DOMAIN: 'green',
  GPO: 'yellow',
  DOMAIN_CONTROLLER: 'red',
  CERT_TEMPLATE: 'pink',
  CONTAINER: 'gray',
};
export const GRAPH_NODE_ICON: Record<InternalNetworkAdEntityKind, TerraIcon> = {
  USER: UserIcon,
  GROUP: UserMultipleIcon,
  COMPUTER: ComputerIcon,
  OU: FolderLibraryIcon,
  DOMAIN: Globe02Icon,
  GPO: FileSlidersIcon,
  DOMAIN_CONTROLLER: ServerStack01Icon,
  CERT_TEMPLATE: FileKeyIcon,
  CONTAINER: CubeIcon,
};
export const GRAPH_NODE_COLOR: Record<InternalNetworkAdEntityKind, string> = {
  USER: token('colors.bg.graphs.sky'),
  GROUP: token('colors.bg.graphs.purple'),
  COMPUTER: token('colors.bg.graphs.gray'),
  OU: token('colors.bg.graphs.orange'),
  DOMAIN: token('colors.fg.accent.default'),
  GPO: token('colors.bg.graphs.yellow'),
  DOMAIN_CONTROLLER: token('colors.bg.graphs.red'),
  CERT_TEMPLATE: token('colors.bg.graphs.pink'),
  CONTAINER: token('colors.bg.graphs.blue'),
};
export const GRAPH_EDGE_COLOR = token('colors.lilac.9');
export type InternalNetworkGraphLayout =
  | 'standard'
  | 'sequential'
  | 'radial'
  | 'horizontal';
export type InternalNetworkGraphLayoutPreset = 'main' | 'drawerPath';
export type InternalNetworkNodeDensity = 'default' | 'compact';
export type InternalNetworkNodeData = {
  label: string;
  entityKind: InternalNetworkAdEntityKind;
  objectId: string;
  distinguishedName?: string | null;
  isCrownJewel: boolean;
  isOwned: boolean;
  samAccountName?: string | null;
  showNodeLabel?: boolean;
  density?: InternalNetworkNodeDensity;
  dimmed?: boolean;
  hidden?: boolean;
  highlighted?: boolean;
};
